import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DataContextService } from '@seahorse/common';
import { AISMarkerModel } from '../models/ais-marker.model';

@Injectable({
  providedIn: 'root',
})
export class BaseMapDataService {
  private dataContext = inject(DataContextService);

  constructor() {}

  getMarkerForMMSI(mmsi: string): Observable<AISMarkerModel> {
    return this.dataContext
      .get<AISMarkerModel>('ais/mmsi/' + mmsi)
      .pipe(map((response) => response.result));
  }
}
